export default function ViewIconSVG() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="view-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon
          id="Path-5"
          fill="#21CB00"
          points="12.296317 11.7509766 14.5676618 15.8931362 4.28571429 19.6648996 10.4598214 15 6.75209263 11.7509766 16.4330357 6.85714286"
        ></polygon>
        <polyline
          id="Path-6"
          stroke="#21CB00"
          strokeWidth="1.71428571"
          points="10.4330357 4.28571429 19.0044643 4.28571429 19.0044643 12.8571429"
        ></polyline>
      </g>
    </svg>
  )
}
